module.exports = __webpack_public_path__ + "img/logo.49fbff82.svg";